import { ModelBase, observable } from "@shoothill/core";
import { action, computed } from "mobx";
import moment from "moment";
export class CustomerVisitsSiteInstructionsModel extends ModelBase<CustomerVisitsSiteInstructionsModel> {
    public static readonly DEFAULT_ID = null;
    public static readonly DEFAULT_PROJECT_ID = "";
    public static readonly DEFAULT_CUSTOMER_SITE_NOTE = "";
    public static readonly DEFAULT_CUSTOMER_VISITS_SITE_PHOTOS = [];
    public static readonly DEFAULT_CREATED_BY_USER_ID = "";
    public static readonly DEFAULT_CREATED_DATE = new Date();
    public static readonly DEFAULT_IS_DELETED = false;
    public static readonly DEFAULT_LAST_UPDATED_BY_USER_ID = "";
    public static readonly DEFAULT_LAST_UPDATED_DATE = "";
    public static readonly DEFAULT_ROW_VERSION = "";

    @observable
    public id: string | null = CustomerVisitsSiteInstructionsModel.DEFAULT_ID;

    @observable
    public projectId: string | null = CustomerVisitsSiteInstructionsModel.DEFAULT_PROJECT_ID;

    @observable
    public customerSiteNote: string | null = CustomerVisitsSiteInstructionsModel.DEFAULT_CUSTOMER_SITE_NOTE;

    @observable
    public customerVisitsSitePhotos: CustomerVisitsSitePhotosFile[] = CustomerVisitsSiteInstructionsModel.DEFAULT_CUSTOMER_VISITS_SITE_PHOTOS;

    @observable
    public createdByUserId: string | null = CustomerVisitsSiteInstructionsModel.DEFAULT_CREATED_BY_USER_ID;

    @observable
    public createdDate: any = CustomerVisitsSiteInstructionsModel.DEFAULT_CREATED_DATE;

    @observable
    public isDeleted: boolean = CustomerVisitsSiteInstructionsModel.DEFAULT_IS_DELETED;

    @observable
    public lastUpdatedByUserId: string | null = CustomerVisitsSiteInstructionsModel.DEFAULT_LAST_UPDATED_BY_USER_ID;

    @observable
    public lastUpdatedDate: string | null = CustomerVisitsSiteInstructionsModel.DEFAULT_LAST_UPDATED_DATE;

    @observable
    public rowVersion: string | null = CustomerVisitsSiteInstructionsModel.DEFAULT_ROW_VERSION;

    @computed
    public get hasId(): boolean {
        return this.id !== null && this.id !== undefined && this.id !== "";
    }

    @computed
    public get formattedLastUpdatedDate(): string {
        return moment(this.lastUpdatedDate).format("DD/MM/YYYY @ HH:mm");
    }

    @action
    public fromDto(dto: CustomerVisitsSiteInstructionsDTO): void {
        for (let key in dto) {
            if (dto.hasOwnProperty(key)) {
                if (this[key] instanceof Date) {
                    this[key] = new Date(dto[key]);
                } else {
                    this[key] = dto[key];
                }
            }
        }
    }

    @action
    public fromCustomerVisitsSitePhotosFileDTO(dto: CustomerVisitsSitePhotosFile[]): void {
        let processedPhotos: CustomerVisitsSitePhotosFile[] = [];
        for (const photo of dto) {
            processedPhotos.push(photo);
        }
        this.customerVisitsSitePhotos = processedPhotos;
    }

    @action
    public toDto() {
        const CustomerVisitsSiteInstructionsModel: CustomerVisitsSiteInstructionsDTO = {
            id: this.id,
            projectId: this.projectId,
            customerSiteNote: this.customerSiteNote,
            createdByUserId: this.createdByUserId,
            createdDate: this.createdDate,
            isDeleted: this.isDeleted,
            lastUpdatedByUserId: this.lastUpdatedByUserId,
            lastUpdatedDate: this.lastUpdatedDate,
            rowVersion: this.rowVersion,
        };

        return CustomerVisitsSiteInstructionsModel;
    }

    @action
    public reset = () => {
        this.id = CustomerVisitsSiteInstructionsModel.DEFAULT_ID;
        this.projectId = CustomerVisitsSiteInstructionsModel.DEFAULT_PROJECT_ID;
        this.customerSiteNote = CustomerVisitsSiteInstructionsModel.DEFAULT_CUSTOMER_SITE_NOTE;
        this.customerVisitsSitePhotos = CustomerVisitsSiteInstructionsModel.DEFAULT_CUSTOMER_VISITS_SITE_PHOTOS;
    };

    // #Start Custome Validation

    @computed
    public get validateCustomerSiteNote(): string {
        return this.customerSiteNote === CustomerVisitsSiteInstructionsModel.DEFAULT_CUSTOMER_SITE_NOTE ? "Please enter a note" : "";
    }

    // #End Custome Validation
}

export interface CustomerVisitsSiteInstructionsDTO {
    id: string | null;
    projectId: string | null;
    customerSiteNote: string | null;
    createdByUserId: string | null;
    createdDate: string | null;
    isDeleted: boolean;
    lastUpdatedByUserId: string | null;
    lastUpdatedDate: string | null;
    rowVersion: string | null;
}

export interface CustomerVisitsSitePhotosFile {
    id: string | null;
    customerVisitsSiteId: string | null;
    fileName: string;
    photoURL: string;
    createdByUserId: string | null;
    isDeleted: boolean;
    createdDate: string | null;
}

export interface UpsertCustomerVisitsSiteInstructionsRequestDTO {
    customerVisitsSiteInstructions: CustomerVisitsSiteInstructionsDTO;
    customerVisitsSiteInstructionsPhotos: CustomerVisitsSitePhotosFile[];
}

export interface UpsertCustomerVisitsSiteInstructionsResponseDTO {
    customerVisitsSiteInstructions: CustomerVisitsSiteInstructionsDTO;
    customerVisitsSiteInstructionsPhotos: CustomerVisitsSitePhotosFile[];
}

export interface CustomerVisitsSiteInstructionsByIdResponseDTO {
    customerVisitsSiteInstructions: CustomerVisitsSiteInstructionsDTO;
    customerVisitsSiteInstructionsPhotos: CustomerVisitsSitePhotosFile[];
}

export interface CustomerVisitsSiteInstructionsResponseDTO {
    customerVisitsSiteInstructions: CustomerVisitsSiteInstructionsDTO;
    customerVisitsSiteInstructionsPhotos: CustomerVisitsSitePhotosFile[];
}

export interface FormRequestDTO {
    date: string | null;
    projectId: string | null;
    formId: string | null;
}
